/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import Spinner, { SpinnerProps } from './Spinner';
import { ICustomElement, noShadowDOM } from 'component-register';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-spinner': Partial<HTMLElement> &
        SpinnerProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidSpinner(): void {
  customElement(
    'tc-spinner',
    {
      show: false,
      message: undefined,
    },
    (props) => {
      noShadowDOM();

      return <Spinner show={props.show} message={props.message} />;
    }
  );
}
